import { launchGame } from '@bonanza-social/games';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { UseHandleStartQuestClickProps } from './useHandleStartQuestClick.types';

export const useHandleStartQuestClick = ({
  gameIds,
  questId,
  selectedGame,
}: UseHandleStartQuestClickProps) => {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const dispatch = useDispatch();

  const handleQuestClick = () => {
    if (selectedGame) {
      navigation.goBack();
      dispatch(launchGame({ id: selectedGame }));
      return;
    }

    if (!gameIds?.length) {
      return navigation.navigate('SelectGameModal', {
        questId: questId,
      });
    }

    if (gameIds?.length === 1) {
      return dispatch(launchGame({ id: gameIds[0] }));
    }

    return navigation.navigate('SelectGameModal', {
      questId: questId,
      filterGames: true,
    });
  };

  return handleQuestClick;
};
